export default {
	treatment: 'ការព្យាបាល',
	price: 'តម្លៃ',
	description: 'ការពិពណ៌នា',
	updated_at: 'ធ្វើបច្ចុប្បន្នភាព',
	new_service: 'សេវាកម្មថ្មី',
	update_service: 'កែសម្រួលសេវាកម្ម'
};
